const $ = (selector, parent = document) => parent.querySelector(selector);
const $$ = (selector, parent = document) => parent.querySelectorAll(selector);

const itemsPerPage = 6;
let currentPage = 1;
const pagination = $(".pagination");

$$(".filter-grid").forEach(function(filterGrid) {
  const filters = $(".filters", filterGrid);
  const items = $$("ul.grid li", filterGrid);
  const grid = $("ul.grid", filterGrid);

  if (filters) {
    const categories = filters.dataset.categories.split(",");
    const viewAll = filters.querySelector("button");
    const controls = viewAll.getAttribute("aria-controls");
    const list = filters.querySelector("ul");

    categories.forEach(function(category) {
      const listItem = document.createElement("li");
      listItem.setAttribute("role", "presentation");
      const button = document.createElement("button");
      button.setAttribute("role", "tab");
      button.setAttribute("aria-controls", controls);
      button.setAttribute("aria-selected", "false");
      button.setAttribute("data-category", category);
      button.textContent = category;
      listItem.appendChild(button);
      list.appendChild(listItem);
    });

    const filterButtons = $$("button[role='tab']", filters);
    filterButtons.forEach(function(button) {
      button.addEventListener("click", function() {
        currentPage = 1;
        const category = this.dataset.category;
        filterButtons.forEach(function(btn) {
          btn.setAttribute("aria-selected", "false");
        });
        this.setAttribute("aria-selected", "true");

        items.forEach(function(item) {
          if (category === "all") {
            item.classList.remove("filtered");
          } else if (item.dataset.category === category) {
            item.classList.remove("filtered");
          } else {
            item.classList.add("filtered");
          }
        });

        $$("li:not(.filtered)", grid).forEach(function(item, index) {
          if (index >= itemsPerPage) {
            item.classList.add("hidden");
          } else {
            item.classList.remove("hidden");
          } 
        });

        initLoadMore();
        initPagination();
      });
    });
  }
});

function initLoadMore() {
  $$(".grid-load-more").forEach(function(loadMoreSection) {
    const hiddenItems = $$("li.hidden:not(.filtered)", loadMoreSection);
    const loadMoreButton = $(".load-more", loadMoreSection);

    if (!loadMoreButton) {
      return;
    }

    if (hiddenItems.length > 0) {
      loadMoreButton.classList.remove("hidden");
    } else {
      loadMoreButton.classList.add("hidden");
    }
  });
}

function initPagination() {
  const pagination = $(".pagination");
  const paginationList = $(".pagination ul");
  if (!pagination) {
    return;
  }

  const itemsNotFiltered = $$(".grid-load-more .grid li:not(.filtered)");

  if (itemsNotFiltered.length > itemsPerPage) {
    paginationList.innerHTML = "";

    const pages = Math.floor(itemsNotFiltered.length / itemsPerPage);
    
    if (pages === 1) {
      pagination.classList.add("invisible");
      pagination.classList.add("hidden");
      return;
    }

    const previous = document.createElement("li");
    previous.classList.add("previous");
    previous.innerHTML = `<button><span class="sr-only">Previous</span>&lt;</button></button>`;

    //create next button item
    const next = document.createElement("li");
    next.classList.add("next");
    next.innerHTML = `<button><span class="sr-only">Next</span>&gt;</button>`;

    const createPageButton = (pageNumber) => {
      const page = document.createElement("li");
      if (currentPage === pageNumber) {
        page.classList.add("active");
      }
      page.innerHTML = `<button>${pageNumber}</button>`;
      return page;
    };

    const createEllipsis = () => {
      const ellipsis = document.createElement("li");
      ellipsis.classList.add("ellipsis");
      ellipsis.innerHTML = `<span>...</span>`;
      return ellipsis;
    };

    const renderPagination = (currentPage) => {
      paginationList.innerHTML = "";
      paginationList.appendChild(previous);

      if (pages <= 5) {
        for (let i = 1; i <= pages; i++) {
          paginationList.appendChild(createPageButton(i));
        }
      } else {
        if (currentPage > 4) {
          paginationList.appendChild(createPageButton(1));
          paginationList.appendChild(createPageButton(2));
          paginationList.appendChild(createEllipsis());
        } else {
          for (let i = 1; i <= currentPage - 2; i++) {
            paginationList.appendChild(createPageButton(i));
          }
        }

        let startPage = Math.max(1, currentPage - 1);
        let endPage = Math.min(pages, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
          paginationList.appendChild(createPageButton(i));
        }

        if (currentPage < pages - 3) {
          paginationList.appendChild(createEllipsis());
          paginationList.appendChild(createPageButton(pages-1));
          paginationList.appendChild(createPageButton(pages));
        } else if (currentPage + 2 <= pages) {
          for (let i = currentPage + 2; i <= pages; i++) {
            paginationList.appendChild(createPageButton(i));
          }
        }
      }

      paginationList.appendChild(next);
    };

    renderPagination(currentPage);
    pagination.classList.remove("invisible");
    pagination.classList.remove("hidden");
  }
}

$(".grid-load-more .load-more")?.addEventListener("click", function() {
  const loadMoreSection = this.closest(".grid-load-more");
  const hiddenItems = $$("li.hidden:not(.filtered)", loadMoreSection);
  const loadMoreButton = $(".load-more", loadMoreSection);

  hiddenItems.forEach(function(item, index) {
    if (index < itemsPerPage) {
      item.classList.remove("hidden");
    }
    if (index === 0) {
      const link = item.querySelector("a");
      if (link) {
        link.focus();
      }
    }
  });

  if (hiddenItems.length <= itemsPerPage) {
    loadMoreButton.classList.add("hidden");
  }
});

if (pagination) {
  document.addEventListener("click", function(event) {
    const closest = event.target.closest(".pagination button");
    if (!closest) {
      return;
    }

    const itemsNotFiltered = $$(".grid-load-more li:not(.filtered)");
    const pages = Math.floor(itemsNotFiltered.length / itemsPerPage);
    const page = closest.textContent;

    if (page.indexOf("<") > -1) {
      currentPage = Math.max(1, currentPage - 1);
    } else if (page.indexOf(">") > -1) {
      currentPage = Math.min(pages, currentPage + 1);
    } else {
      currentPage = parseInt(page);
    }

    itemsNotFiltered.forEach(function(item, index) {
      if (index < itemsPerPage * (currentPage - 1) || index >= itemsPerPage * currentPage) {
        item.classList.add("hidden");
      } else {
        item.classList.remove("hidden");
      }
    });

    //scroll to section
    const section = $(".grid-load-more");
    const offset = section.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({
      top: offset,
      behavior: "smooth"
    });
    initPagination();
  });
}

initLoadMore();
initPagination();